var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"error-fade"}},[(_vm.errors?.length)?_c('div',{staticClass:"text-left"},[_c('span',{staticClass:"text-error text-xs"},[_vm._v(_vm._s(_vm.errors[0]))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }